export function ListSkeleton({ count = 4 }: { count?: number }) {
  return (
    <div className="divide-y divide-background-200">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="flex animate-pulse gap-4 py-5">
          <div className="min-w-0 flex-1 space-y-3">
            <div className="h-4 w-16 rounded bg-background-200"></div>
            <div className="h-5 w-3/4 rounded bg-background-200"></div>
            <div className="h-4 w-full rounded bg-background-200"></div>
            <div className="h-3 w-40 rounded bg-background-200"></div>
          </div>
          <div className="hidden h-24 w-36 shrink-0 rounded-md bg-background-200 sm:block"></div>
        </div>
      ))}
    </div>
  );
}

export function CardSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="animate-pulse overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className="h-44 w-full bg-background-200"></div>
          <div className="space-y-3 p-4">
            <div className="h-5 w-full rounded bg-background-200"></div>
            <div className="h-5 w-2/3 rounded bg-background-200"></div>
            <div className="h-4 w-full rounded bg-background-200"></div>
          </div>
        </div>
      ))}
    </div>
  );
}